var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileTxt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-txt_svg__file-txt_svg__Canvas",
    transform: "translate(6533 -1382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt_svg__file-txt_svg__txt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt_svg__file-txt_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt_svg__file-txt_svg__Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt_svg__file-txt_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt_svg__file-txt_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-txt_svg__file-txt_svg__path0_fill",
    transform: "translate(-6533 1382)",
    fill: "#D9DEE0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-txt_svg__file-txt_svg__Burger_Angus_Burger"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-txt_svg__file-txt_svg__path1_fill",
    transform: "translate(-6524 1407)",
    fill: "#556080"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-txt_svg__file-txt_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-txt_svg__file-txt_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-txt_svg__file-txt_svg__path2_fill",
    transform: "matrix(1 0 0 -1 -6522 1397)",
    fill: "#556080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-txt_svg__file-txt_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-txt_svg__file-txt_svg__path2_fill",
    transform: "matrix(1 0 0 -1 -6522 1399)",
    fill: "#556080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-txt_svg__file-txt_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-txt_svg__file-txt_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -6527 1401)",
    fill: "#556080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-txt_svg__file-txt_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-txt_svg__file-txt_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -6527 1403)",
    fill: "#556080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-txt_svg__file-txt_svg__T"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-txt_svg__file-txt_svg__path5_fill",
    transform: "translate(-6527 1394)",
    fill: "#556080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-txt_svg__file-txt_svg__Rectangle_11"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-txt_svg__file-txt_svg__path2_fill",
    transform: "matrix(1 0 0 -1 -6522 1395)",
    fill: "#556080"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "file-txt_svg__file-txt_svg__path0_fill",
    d: "M 20.7146 0L 2.07105 0C 0.928471 0 -3.14132e-09 0.8996 -3.14132e-09 2.0124L -3.14132e-09 33.9876C -3.14132e-09 35.0992 0.928471 36 2.07105 36L 26.929 36C 28.074 36 29 35.0992 29 33.9876L 29 8.0496L 20.7146 0ZM 20.7146 2.8452L 26.0717 8.0496L 20.7146 8.0496L 20.7146 2.8452ZM 26.9294 33.9876L 2.07105 33.9876L 2.07105 2.0124L 18.6431 2.0124L 18.6431 8.0496C 18.6431 9.1612 19.5695 10.062 20.7142 10.062L 26.929 10.062L 26.929 33.9876L 26.9294 33.9876Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-txt_svg__file-txt_svg__path1_fill",
    d: "M 3.588 0.314C 3.672 0.314 3.74 0.342 3.792 0.398C 3.848 0.45 3.876 0.518 3.876 0.602C 3.876 0.686 3.848 0.756 3.792 0.812C 3.74 0.864 3.672 0.89 3.588 0.89L 2.298 0.89L 2.298 4.688C 2.298 4.776 2.268 4.85 2.208 4.91C 2.148 4.97 2.074 5 1.986 5C 1.898 5 1.824 4.97 1.764 4.91C 1.704 4.85 1.674 4.776 1.674 4.688L 1.674 0.89L 0.378 0.89C 0.294 0.89 0.224 0.864 0.168 0.812C 0.116 0.756 0.09 0.686 0.09 0.602C 0.09 0.518 0.116 0.45 0.168 0.398C 0.224 0.342 0.294 0.314 0.378 0.314L 3.588 0.314ZM 7.9088 4.496C 7.9528 4.56 7.9748 4.628 7.9748 4.7C 7.9748 4.78 7.9488 4.85 7.8968 4.91C 7.8448 4.97 7.7748 5 7.6868 5C 7.5868 5 7.5068 4.962 7.4468 4.886L 6.1448 3.08L 4.7648 4.91C 4.7048 4.97 4.6328 5 4.5488 5C 4.4608 5 4.3908 4.972 4.3388 4.916C 4.2908 4.86 4.2668 4.792 4.2668 4.712C 4.2668 4.632 4.2908 4.56 4.3388 4.496L 5.7368 2.636L 4.4168 0.806C 4.3768 0.754 4.3568 0.692 4.3568 0.62C 4.3568 0.536 4.3828 0.464 4.4348 0.404C 4.4868 0.344 4.5568 0.314 4.6448 0.314C 4.7488 0.314 4.8228 0.344 4.8668 0.404L 6.1568 2.192L 7.5008 0.404C 7.5568 0.344 7.6308 0.314 7.7228 0.314C 7.8068 0.314 7.8728 0.342 7.9208 0.398C 7.9728 0.454 7.9988 0.522 7.9988 0.602C 7.9988 0.67 7.9768 0.738 7.9328 0.806L 6.5648 2.63L 7.9088 4.496ZM 11.8497 0.314C 11.9337 0.314 12.0017 0.342 12.0537 0.398C 12.1097 0.45 12.1377 0.518 12.1377 0.602C 12.1377 0.686 12.1097 0.756 12.0537 0.812C 12.0017 0.864 11.9337 0.89 11.8497 0.89L 10.5597 0.89L 10.5597 4.688C 10.5597 4.776 10.5297 4.85 10.4697 4.91C 10.4097 4.97 10.3357 5 10.2477 5C 10.1597 5 10.0857 4.97 10.0257 4.91C 9.96572 4.85 9.93572 4.776 9.93572 4.688L 9.93572 0.89L 8.63972 0.89C 8.55572 0.89 8.48572 0.864 8.42972 0.812C 8.37772 0.756 8.35172 0.686 8.35172 0.602C 8.35172 0.518 8.37772 0.45 8.42972 0.398C 8.48572 0.342 8.55572 0.314 8.63972 0.314L 11.8497 0.314Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-txt_svg__file-txt_svg__path2_fill",
    d: "M 0 0L 11 0L 11 1L 0 1L 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-txt_svg__file-txt_svg__path3_fill",
    d: "M 0 0L 16 0L 16 1L 0 1L 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-txt_svg__file-txt_svg__path4_fill",
    d: "M 0 0L 12 0L 12 1L 0 1L 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-txt_svg__file-txt_svg__path5_fill",
    d: "M 4 0L 4 0.885346L 2.52261 0.885346L 2.52261 5L 1.48409 5L 1.48409 0.885346L 0 0.885346L 0 0L 4 0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTxt);
export default __webpack_public_path__ + "static/media/file-txt.a3d2c9dfb6e5c8745834ede9b7e419ae.svg";
export { ForwardRef as ReactComponent };